import {
  type QuizQuestionRank,
  type QuizQuestionRankOption,
} from '@efdigital/ll-addon-data';
import { uniqueId } from '@ember/helper';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';

import type { QuizQuestionScoringEditorComponentSignature } from '../../types/question-manager';
import { Category } from './shared/category.gts';

function not(value: boolean) {
  return !value;
}

export class RankScoringEditorComponent extends Component<QuizQuestionScoringEditorComponentSignature> {
  get questionData(): QuizQuestionRank {
    return this.args.question.rank!;
  }

  setOptionCategory = (option: QuizQuestionRankOption, category: string) => {
    option.category = category;
  };

  get isRankAscending(): boolean {
    return this.questionData.scoring === 'ascending';
  }

  setRankAscending = () => {
    this.questionData.scoring = 'ascending';
  };

  setRankDescending = () => {
    this.questionData.scoring = 'descending';
  };

  <template>
    <div class="card-body">
      <div class="form-label">
        Each option can be linked to a category. When a user ranks the options,
        the placement of each option will be used as the score for its
        associated category.
      </div>

      <div class="mb-4">
        <div class="form-check">
          <input
            type="radio"
            class="form-check-input"
            id="{{uniqueId}}-rank-descending"
            value="individual"
            checked={{not this.isRankAscending}}
            {{on "change" this.setRankDescending}}
          />
          <label class="form-check-label" for="{{uniqueId}}-rank-descending">
            The lowest ranked option scores 1. The highest ranked option
            receives the highest score.
          </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            class="form-check-input"
            id="{{uniqueId}}-rank-ascending"
            value="individual"
            checked={{this.isRankAscending}}
            {{on "change" this.setRankAscending}}
          />
          <label class="form-check-label" for="{{uniqueId}}-rank-ascending">
            The highest ranked option scores 1. The lowest ranked option
            receives the highest score.
          </label>
        </div>
      </div>

      {{#each this.questionData.options as |option|}}
        <div class="mt-4">
          <Category
            @quiz={{@quiz}}
            @category={{option.category}}
            @onChange={{fn this.setOptionCategory option}}
          >
            <:label as |id|>
              <label for={{id}} class="h5 mt-1 mb-2">{{option.value}}</label>
            </:label>
          </Category>
        </div>
      {{/each}}
    </div>
  </template>
}
